"use client";

export default function ShippingRequestDocumentWrapper({ children }) {
  return (
    <div className="quote-a4">
      <style jsx global>{`
        .quote-a4 {
          width: 210mm;
          max-width: calc(100vw - 32px);
          min-height: 297mm;
          margin: 20px auto;
          padding: 10mm;
          background: white;
          box-shadow: 0 0 15px rgba(0,0,0,0.1);
          box-sizing: border-box;
          font-family: 'Times New Roman', Times, serif;
          font-size: 12pt;
          line-height: 1.5;
          color: #000;
          overflow-x: auto;
          overflow-y: hidden;
          contain: layout paint;
        }

        .shipping-request-banner {
          aspect-ratio: 3714 / 722;
          width: 100%;
          overflow: hidden;
        }

        .shipping-request-banner img {
          height: auto;
        }

        @media print {
          body { margin: 0; padding: 0; background: white !important; }
          .quote-a4 {
            width: 100% !important;
            min-height: auto !important;
            margin: 0 !important;
            padding: 10mm !important;
            box-shadow: none !important;
            page-break-after: always;
          }
          .no-print { display: none !important; }
          input, textarea { border: none !important; background: transparent !important; }
          input::placeholder, textarea::placeholder { color: #999 !important; }
        }

        .quote-a4 h1 {
          text-align: center;
          font-size: 18pt;
          font-weight: bold;
          text-transform: uppercase;
          margin: 0 0 10px 0;
        }
      `}</style>
      {children}
    </div>
  );
}
